"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _vue = _interopRequireDefault(require("vue"));
var _strftime = _interopRequireDefault(require("strftime"));
var bufferTools = _interopRequireWildcard(require("@/libs/bufferTools"));
var _RemoveBeforeUpdate = _interopRequireDefault(require("./utils/RemoveBeforeUpdate"));
var _MessageListMessageCompact = _interopRequireDefault(require("./MessageListMessageCompact"));
var _MessageListMessageModern = _interopRequireDefault(require("./MessageListMessageModern"));
var _MessageListMessageInline = _interopRequireDefault(require("./MessageListMessageInline"));
var _LoadingAnimation = _interopRequireDefault(require("./LoadingAnimation"));
var _BufferKey = _interopRequireDefault(require("./BufferKey"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
require('@/libs/polyfill/Element.closest');

// If we're scrolled up more than this many pixels, don't auto scroll down to the bottom
// of the message list
const BOTTOM_SCROLL_MARGIN = 60;

// CHATSI_HIDE_NICKSERV_SERVIDOR_V1
const CHATSI_HIDDEN_SERVICE_MESSAGES = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
const CHATSI_SERVICE_NICK_PARTS = ['nickserv', 'servidor'];
const CHATSI_SERVICE_NOTICE_PARTS = ['contraseña aceptada', 'has sido reconocido', 'has iniciado sesión como', 'ya estás identificado', 'password accepted', 'you are now identified', 'already identified'];
function chatsiValueToText(value) {
  if (value === null || value === undefined) {
    return '';
  }
  if (Array.isArray(value)) {
    return value.map(chatsiValueToText).join(' ');
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return '';
    }
  }
  return String(value);
}
function chatsiMessageSourceNick(message) {
  if (!message) {
    return '';
  }
  return chatsiValueToText(message.nick || message.from || message.sender || message.source || message.prefix || '');
}
function chatsiMessageBodyText(message) {
  if (!message) {
    return '';
  }
  return [message.message, message.text, message.body, message.params, message.command, message.type, message.type_extra].map(chatsiValueToText).join(' ');
}
function chatsiLogHiddenServiceMessage(message, sourceNick, bodyText) {
  if (CHATSI_HIDDEN_SERVICE_MESSAGES && message && typeof message === 'object' && CHATSI_HIDDEN_SERVICE_MESSAGES.has(message)) {
    return;
  }
  if (CHATSI_HIDDEN_SERVICE_MESSAGES && message && typeof message === 'object') {
    CHATSI_HIDDEN_SERVICE_MESSAGES.add(message);
  }
  try {
    // eslint-disable-next-line no-console
    console.log('[CHATSI servicio oculto]', {
      sourceNick,
      type: message && message.type ? message.type : '',
      message: bodyText
    });
  } catch (e) {}
}
function chatsiShouldHideServiceMessage(message) {
  const sourceNick = chatsiMessageSourceNick(message).toLowerCase();
  const bodyText = chatsiMessageBodyText(message).toLowerCase();
  let shouldHide = CHATSI_SERVICE_NICK_PARTS.some(nickPart => sourceNick.indexOf(nickPart) !== -1);
  if (!shouldHide && bodyText.indexOf('[notice]') !== -1) {
    shouldHide = CHATSI_SERVICE_NOTICE_PARTS.some(noticePart => bodyText.indexOf(noticePart) !== -1);
  }
  if (shouldHide) {
    chatsiLogHiddenServiceMessage(message, sourceNick, bodyText);
  }
  return shouldHide;
}
var _default = exports.default = {
  components: {
    RemoveBeforeUpdate: _RemoveBeforeUpdate.default,
    MessageListMessageModern: _MessageListMessageModern.default,
    MessageListMessageCompact: _MessageListMessageCompact.default,
    MessageListMessageInline: _MessageListMessageInline.default,
    LoadingAnimation: _LoadingAnimation.default,
    BufferKey: _BufferKey.default
  },
  props: ['buffer'],
  data() {
    return {
      smooth_scroll: false,
      auto_scroll: true,
      force_smooth_scroll: null,
      chathistoryAvailable: true,
      hover_nick: '',
      message_info_open: null,
      timeToClose: false,
      startClosing: false,
      selectedMessages: Object.create(null)
    };
  },
  computed: {
    thisMl() {
      return this;
    },
    shouldAutoEmbed() {
      if (this.buffer.isChannel() && this.buffer.setting('inline_link_auto_previews')) {
        return true;
      }
      if (this.buffer.isQuery() && this.buffer.setting('inline_link_auto_previews_query')) {
        return true;
      }
      return false;
    },
    listType() {
      return 'inline';
    },
    useExtraFormatting() {
      // Enables simple markdown formatting
      return this.buffer.setting('extra_formatting');
    },
    shouldShowChathistoryTools() {
      // Only show it if we're connected
      if (this.buffer.getNetwork().state !== 'connected') {
        return false;
      }
      let isCorrectBufferType = this.buffer.isChannel() || this.buffer.isQuery();
      let isSupported = !!this.buffer.getNetwork().ircClient.chathistory.isSupported();
      return isCorrectBufferType && isSupported && (0, _flags.default)(this.buffer).chathistory_available;
    },
    shouldRequestChannelKey() {
      return this.buffer.getNetwork().state === 'connected' && this.buffer.isChannel() && (0, _flags.default)(this.buffer).channel_badkey;
    },
    ourNick() {
      return this.buffer ? this.buffer.getNetwork().nick : '';
    },
    filteredMessagesGroupedDay() {
      // Group messages by day

      const days = [];
      let lastDay = null;
      this.filteredMessages.forEach(message => {
        if (!lastDay || message.day_num !== lastDay) {
          days.push({
            dayNum: message.day_num,
            messages: []
          });
          lastDay = message.day_num;
        }
        days[days.length - 1].messages.push(message);
      });
      return days;
    },
    filteredMessages() {
      return bufferTools.orderedMessages(this.buffer).filter(message => !chatsiShouldHideServiceMessage(message));
    },
    shouldShowJoiningLoader() {
      return this.buffer.isChannel() && this.buffer.enabled && !this.buffer.joined && this.buffer.getNetwork().state === 'connected';
    }
  },
  watch: {
    filteredMessages() {
      // Data has changed and now preparing to update the DOM.
      // Check our scrolling state before the DOM updates so that we know if we're scrolled
      // at the bottom before new messages are added
      this.checkScrollingState();

      // Wait until after the DOM has updated before possibly scrolling down based on the
      // previous check
      this.$nextTick(() => {
        this.maybeScrollToBottom();
      });
    },
    buffer(newBuffer, oldBuffer) {
      if (oldBuffer) {
        oldBuffer.isMessageTrimming = true;
      }
      if (!newBuffer) {
        return;
      }
      this.message_info_open = null;
      if (this.buffer.getNetwork().state === 'connected') {
        (0, _flags.default)(newBuffer).has_opened = true;
      }
      this.auto_scroll = true;
      this.force_smooth_scroll = false;
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
  },
  mounted() {
    this.addCopyListeners();
    this.$nextTick(() => {
      this.scrollToBottom();
      // this.smooth_scroll = true;
    });
    this.listen(this.$state, 'mediaviewer.opened', () => {
      this.$nextTick(this.maybeScrollToBottom.apply(this));
    });
    this.listen(this.$state, 'messagelist.scrollto', opt => {
      if (opt && opt.id) {
        this.maybeScrollToId(opt.id);
      }
    });
  },
  methods: {
    isTemplateVue(template) {
      const isVue = template instanceof _vue.default;
      if (isVue && !window.kiwi_deprecations_messageTemplate) {
        window.kiwi_deprecations_messageTemplate = true;
        // eslint-disable-next-line no-console
        console.warn('deprecated message.template or message.bodyTemplate, please use `message.template = kiwi.Vue.extend(component object)`');
      }
      return isVue;
    },
    isHoveringOverMessage(message) {
      return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
    },
    toggleMessageInfo(message) {
      if (!message) {
        this.message_info_open = null;
      } else if (this.message_info_open === message) {
        // It's already open, so don't do anything
      } else if (this.canShowInfoForMessage(message)) {
        // If in the process of selecting text, don't show the info box
        let sel = window.getSelection();
        if (sel.rangeCount > 0) {
          let range = sel.getRangeAt(0);
          if (range && !range.collapsed) {
            return;
          }
        }
        this.message_info_open = message;
        this.$nextTick(() => this.maybeScrollToId(message.id));
      }
    },
    shouldShowUnreadMarker(message) {
      let idx = this.filteredMessages.indexOf(message);
      let previous = this.filteredMessages[idx - 1];
      let current = this.filteredMessages[idx];
      let lastRead = this.buffer.last_read;
      if (!lastRead) {
        return false;
      }
      if (!current) {
        return false;
      }

      // If the last message has been read, and this message not read
      if (previous && previous.time < lastRead && current.time > lastRead) {
        return true;
      }
      return false;
    },
    shouldShowDateChangeMarker(idx) {
      let previous = this.filteredMessages[idx - 1];
      let current = this.filteredMessages[idx];
      if (!previous && new Date(current.time).getDay() !== new Date().getDay()) {
        // The first message of the lsit and it's not today
        return true;
      } else if (!previous) {
        // The first message of the lsit but it's today
        return false;
      }

      // If the last message has been read, and this message not read
      if (new Date(previous.time).getDay() !== new Date(current.time).getDay()) {
        return true;
      }
      return false;
    },
    canShowInfoForMessage(message) {
      let showInfoForTypes = ['privmsg', 'notice', 'action'];
      return showInfoForTypes.indexOf(message.type) > -1;
    },
    bufferSetting(key) {
      return this.buffer.setting(key);
    },
    formatTime(time) {
      return (0, _strftime.default)(this.buffer.setting('timestamp_format') || '%T', new Date(time));
    },
    formatTimeFull(time) {
      let format = this.buffer.setting('timestamp_full_format');
      return format ? (0, _strftime.default)(format, new Date(time)) : new Date(time).toLocaleString();
    },
    formatMessage(message) {
      return message.toHtml(this);
    },
    isMessageHighlight(message) {
      // Highlighting ourselves when we join or leave a channel is silly
      if (message.type === 'traffic') {
        return false;
      }
      return message.isHighlight;
    },
    userColour(user) {
      if (user && this.bufferSetting('colour_nicknames_in_messages')) {
        return user.getColour();
      }
      return '';
    },
    openUserBox(nick) {
      let user = this.$state.getUser(this.buffer.networkid, nick);
      if (user) {
        this.$state.$emit('userbox.show', user, {
          buffer: this.buffer
        });
      }
    },
    onListClick(event) {
      this.toggleMessageInfo();
    },
    onMessageDblClick(event, message) {
      clearTimeout(this.messageClickTmr);
      let dataNick = event.target.getAttribute('data-nick');
      if (!dataNick) {
        return;
      }
      let network = this.buffer.getNetwork();
      let user = network.userByName(dataNick);
      // The user might have left use dataNick as fallback
      let nick = user && user.nick ? user.nick : dataNick;
      this.$state.$emit('input.insertnick', nick);
    },
    onMessageClick(event, message, delay) {
      // Delaying the click for 200ms allows us to check for a second click. ie. double click
      // Quick hack as we only need double click for nicks, nothing else
      if (delay && event.target.getAttribute('data-nick')) {
        clearTimeout(this.messageClickTmr);
        this.messageClickTmr = setTimeout(this.onMessageClick, 200, event, message, false);
        return;
      }
      let isLink = event.target.tagName === 'A';
      let channelName = event.target.getAttribute('data-channel-name');
      if (channelName && isLink) {
        let network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
        this.$state.setActiveBuffer(this.buffer.networkid, channelName);
        return;
      }
      let userNick = event.target.getAttribute('data-nick');
      if (userNick && isLink) {
        this.openUserBox(userNick);
        return;
      }
      let url = event.target.getAttribute('data-url');
      if (url && isLink) {
        if (this.$state.setting('buffers.inline_link_auto_previews')) {
          message.embed.type = 'url';
          message.embed.payload = url;
        } else {
          this.$state.$emit('mediaviewer.show', url);
        }
        return;
      }
      let avatarElement = event.target.closest('.kiwi-avatar');
      if (avatarElement && avatarElement.dataset.nick) {
        this.openUserBox(avatarElement.dataset.nick);
        return;
      }
      if (this.message_info_open && this.message_info_open !== message) {
        // Clicking on another message while another info is open, just close the info
        this.toggleMessageInfo();
        event.preventDefault();
        return;
      }
      if (this.$state.ui.is_touch && this.$state.setting('buffers.show_message_info')) {
        if (this.canShowInfoForMessage(message) && event.target.nodeName === 'A') {
          // We show message info boxes on touch screen devices so that the user has an
          // option to preview the links or do other stuff.
          event.preventDefault();
        }
        this.toggleMessageInfo(message);
      }
    },
    checkScrollingState() {
      let el = this.$el;
      let scrolledUpByPx = el.scrollHeight - (el.offsetHeight + el.scrollTop);

      // We need to know at this point (before the DOM has updated with new messages) if we
      // are at the bottom of the messagelist or not, otherwise once the DOM has updated then
      // it is too late to determine if we should auto scroll down
      if (scrolledUpByPx > BOTTOM_SCROLL_MARGIN) {
        this.auto_scroll = false;
        this.buffer.isMessageTrimming = false;
      } else {
        this.auto_scroll = true;
        this.buffer.isMessageTrimming = true;
      }
      if (this.force_smooth_scroll !== null) {
        this.smooth_scroll = this.force_smooth_scroll;
        this.force_smooth_scroll = null;
        // TODO: Enabling smooth_scroll breaks the auto-scroll-to-bottom on fast buffers as
        //       it takes time to scroll down and it looks like we're scrolled too far up when
        //       detecting if were scrolled up or not. Look into ways around this so that we
        //       can enable it as it does look a lot better.
        // } else if (scrolledUpByPx < BOTTOM_SCROLL_MARGIN) {
        //    this.smooth_scroll = true;
      } else {
        this.smooth_scroll = false;
      }
    },
    onListResize(e) {
      // The messagelist or interface has resized or had new content added
      // check if we should auto scroll down to the bottom
      this.maybeScrollToBottom();
    },
    scrollToBottom() {
      this.$el.scrollTop = this.$el.scrollHeight;
    },
    maybeScrollToBottom() {
      if (this.auto_scroll) {
        this.scrollToBottom();
      }
    },
    maybeScrollToId(id, position = 'middle') {
      let msgEl = this.$el.querySelector('.kiwi-messagelist-message[data-message-id="' + id + '"]');
      if (!msgEl) {
        return;
      }
      let newTop = 0;
      if (position === 'top') {
        // There maybe a sticky unread marker at the top
        newTop = msgEl.offsetTop;
      } else if (position === 'bottom') {
        newTop = Math.floor(msgEl.offsetTop - this.$refs.scroller.offsetHeight + msgEl.offsetHeight);
      } else {
        newTop = Math.floor(msgEl.offsetTop - (this.$refs.scroller.offsetHeight - msgEl.offsetHeight) / 2);
      }
      this.auto_scroll = false;
      this.$refs.scroller.scrollTo({
        top: newTop,
        behavior: 'smooth'
      });
    },
    getSelectedMessages() {
      let sel = document.getSelection();
      let r = sel.getRangeAt(0);
      let messageEls = [...this.$el.querySelectorAll('.kiwi-messagelist-message')];
      let selectedMessageEls = messageEls.filter(el => r.intersectsNode(el));
      return selectedMessageEls;
    },
    restrictTextSelection() {
      // Prevents the selection cursor escaping the message list.
      document.querySelector('body').classList.add('kiwi-unselectable');
      this.$el.style.userSelect = 'text';
    },
    unrestrictTextSelection() {
      // Allows all page elements to be selected again.
      document.querySelector('body').classList.remove('kiwi-unselectable');
      this.$el.style.userSelect = 'auto';
    },
    removeSelections(removeNative = false) {
      this.selectedMessages = Object.create(null);
      let selection = document.getSelection();
      if (removeNative && selection) {
        // stops the native browser selection being left behind after ctrl+c
        selection.removeAllRanges();
      }
    },
    addCopyListeners() {
      // Better copy pasting
      const LogFormatter = msg => {
        let text = '';
        switch (msg.type) {
          case 'privmsg':
            text = `<${msg.nick}> ${msg.message}`;
            break;
          case 'nick':
          case 'mode':
          case 'action':
          case 'traffic':
            text = `${msg.message}`;
            break;
          default:
            text = msg.message;
        }
        if (text.length) {
          return `[${new Date(msg.time).toLocaleTimeString({
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          })}] ${text}`;
        }
        return null;
      };
      let copyData = '';
      let selecting = false;
      let selectionChangeOff = null;
      this.listen(document, 'selectstart', e => {
        if (!this.$el.contains(e.target)) {
          // Selected elsewhere on the page
          copyData = '';
          this.removeSelections();
          return;
        }
        this.removeSelections();
        selectionChangeOff = this.listen(document, 'selectionchange', onSelectionChange);
      });
      this.listen(document, 'mouseup', e => {
        selectionChangeOff && selectionChangeOff();
        this.unrestrictTextSelection();
        if (selecting) {
          e.preventDefault();
        }
        selecting = false;
      });
      let onSelectionChange = e => {
        if (!this.$el) {
          return true;
        }
        copyData = ''; // Store the text data to be copied in this.

        let selection = document.getSelection();
        if (!selection || !selection.anchorNode || !selection.anchorNode.parentNode.closest('.' + this.$el.className)) {
          this.unrestrictTextSelection();
          this.removeSelections();
          return true;
        }
        this.removeSelections();
        // Prevent the selection escaping the message list
        this.restrictTextSelection();
        if (selection.rangeCount > 0) {
          selecting = true;
          let selectedMesssageEls = this.getSelectedMessages();
          let selectedMessages = [];
          selectedMesssageEls.forEach(el => {
            let m = this.buffer.messagesObj.messageIds[el.dataset.messageId];
            if (m) {
              selectedMessages.push(m);
            }
          });

          // If only 1 message is selected then treat the selection as native text
          // selection. Most likely copying part of a message only.
          if (selectedMessages.length === 1) {
            selectedMessages = [];
          }
          this.selectedMessages = Object.create(null);
          selectedMessages.forEach(m => {
            this.selectedMessages[m.id] = m;
          });

          // Iterate through the selected messages, format and store as a
          // string to be used in the copy handler
          copyData = selectedMessages.sort((a, b) => a.time > b.time ? 1 : -1).filter(m => m.message.trim().length).map(LogFormatter).join('\r\n');
        } else {
          this.unrestrictTextSelection();
        }
        return false;
      };
      this.listen(document, 'copy', e => {
        if (!copyData || !copyData.length) {
          // Just do a normal copy if no special data
          return true;
        }
        if (navigator.clipboard) {
          // Supports Clipboard API
          navigator.clipboard.writeText(copyData);
        } else {
          let input = document.createElement('textarea');
          document.body.appendChild(input);
          input.innerHTML = copyData;
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        return true;
      });
    },
    // Move a messages embeded content to the main media preview
    openEmbedInPreview(message) {
      // First open the embed in the main media preview
      let embed = message.embed;
      if (embed.type === 'url') {
        this.$state.$emit('mediaviewer.show', embed.payload);
      } else if (embed.type === 'component') {
        this.$state.$emit('mediaviewer.show', {
          component: embed.payload
        });
      }

      // Remove the embed from the message
      embed.payload = null;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageList"]
window._kiwi_exports.components.MessageList = exports.default ? exports.default : exports;
